document.addEventListener('DOMContentLoaded',
  function () {
    requirejs([
        'vendor/vue/vue.min',
        'common/components/vue/grid-calendar',
        'common/components/accordion',
        'common/components/tabs',
        'vendor/tiny.slider',
        'common/util.element',
        'common/components/axios',
        'common/components/mask-phone'
      ],
      function (Vue, GridCalendar, accordion, tabs, carousel, utilElement, axios, maskPhone) {
        const pages = [];

        if (window.periods && window.periods.length > 0) {
          const disabledDates = [];

          for (let i = 0; i < window.unavailableDates.length; i++) {
            const date = window.unavailableDates[i];
            const dateObject = new Date(date);

            disabledDates.push(new Date(dateObject.setHours(0, 0, 0, 0)));
          }

          GridCalendar();

          const page = new Vue({
            el: '#grid-calendar',
            data: {
              showGrid: true,
              gridReadOnly: true,
              form: {
                unavailableDates: disabledDates,
                periods: window.periods.filter((period) => period.showInAdvertisement)
              }
            }
          });

          pages.push(page);
        }

        const mediaTabs = function () {
          if (document.querySelector('.advertisement .three-d-street-view') != null) {


            // SOMENTE SE TIVER VIDEOS DEVE SER FEITO REQUIREJS
            requirejs(['common/components/videojs'], function (videojs) {

              function webglSupport() {
                try {
                  var canvas = document.createElement('canvas');
                  return !!(window.WebGLRenderingContext && (canvas.getContext('webgl') || canvas.getContext('experimental-webgl')));
                } catch (e) {
                  return false;
                }
              };

              if (webglSupport()) {

                videojs(function (PANOLENS) {

                  var viewers = [];

                  var containers = document.querySelectorAll('.panolens')
                  var bodyFather = document.querySelector('.body-tab-content')

                  if (containers.length === 0) {
                    return false;
                  }

                  for (var i = 0; i < containers.length; i++) {
                    let container = containers[i];

                    let panorama = new PANOLENS.VideoPanorama(container.dataset.src, {
                      loop: false
                    });

                    let viewer = new PANOLENS.Viewer({
                      container: container
                    });
                    viewer.add(panorama);

                    viewers.push(viewer);
                  }

                  const updateDomAfterRenderFunction = generateChangeContainerSizeFunction(bodyFather, viewers);

                  var resizeTimeout;
                  function resizeThrottler() {
                    if (!resizeTimeout) {
                      resizeTimeout = setTimeout(function () {
                        resizeTimeout = null;
                        updateDomAfterRenderFunction();
                      }, 200);
                    }
                  }

                  // Update Panorama size on window resize
                  window.addEventListener("resize", resizeThrottler, false);

                  // Fix rendering problem, force render after dom is built by panolens
                  setTimeout(updateDomAfterRenderFunction, 1000);
                });
              } else {
                document.querySelectorAll('.feedback.message-ie').forEach((el) => el.classList.add('show') );
              }

            });

          }
          tabs();


          let carrouselElements = document.querySelectorAll('.body-tab-content .lazyload');
          if (carrouselElements !== undefined && carrouselElements !== null) {
            for (var i = 0; i < carrouselElements.length; i++) {
              renderSlider(carrouselElements[i]);
            }
          }
          // Build and load everything related to modal
          loadImgModal(carousel);

        }

        mediaTabs();

        setupContactForm(axios, maskPhone);

        function labelCount(selector, info) {
          let labelImageCount = document.querySelector(selector);
          if (info) {
            labelImageCount.innerHTML = `${info.index + 1} de ${info.slideCount}`;
          }
        }

        function renderSlider(elementCarousel) {
          var total = elementCarousel.querySelectorAll('.images-grid').length;
          labelCount('.' + elementCarousel.dataset.count, {
            index: 0,
            slideCount: total
          });

          let _carousel = carousel({
            container: elementCarousel,
            items: 1,
            slideBy: 'page',
            lazyload: true,
            nav: false,
            loop: false,
            responsive: true,
            controlsText: [
              `<span class="icon-angle-left" data-count="${elementCarousel.dataset.count}"></span>`,
              `<span class="icon-angle-right" data-count="${elementCarousel.dataset.count}"></span>`
            ],
            onInit: (e) => {
              let el = document.querySelector('.body-tab-content');
              utilElement.removeClass(el, 'midia-wrapper');
            }
          });
          if (_carousel) {
            _carousel.events.on('indexChanged', (info) => {
              let nextButton = info.nextButton.querySelector('span');
              labelCount('.' + nextButton.dataset.count, info);
            })
          }
        }
      }
    );

    function loadImgModal(carousel) {
      const modalDeteilImg = document.querySelector('.modal-detail-img');
      var bodyFixed = document.querySelector('body');

      carousel({
        container: modalDeteilImg.querySelector('.lazyload'),
        items: 1,
        slideBy: 'page',
        lazyload: true,
        navAsThumbnails: true,
        navContainer: modalDeteilImg.querySelector('.thumbnails ul'),
        nav: true,
        loop: false,
        responsive: true,
        controlsText: [
          `<span class="icon-angle-left"></span>`,
          `<span class="icon-angle-right"></span>`
        ],
      });

      let btnClose = modalDeteilImg.querySelector('.icon-close');
      btnClose.addEventListener('click', function () {
        modalDeteilImg.classList.remove('show');
        bodyFixed.classList.remove('body-fixed');
      });

      // TODO: Colocar somente um evento no elemento pai
      Array.prototype.forEach.call(document.querySelectorAll('.tabs-creci.secondary .img-fluid'), function (elem) {
        elem.addEventListener('click', function () {
          modalDeteilImg.classList.add('show');
          bodyFixed.classList.add('body-fixed');
        });
      });
    }

    function setupContactForm(axios, maskPhone) {
      const forms = [
        document.getElementById('BrokerMessageRight'),
        document.getElementById('BrokerMessageBottom')
      ];
      maskPhone('#BrokerMessageRight #Phone');
      maskPhone('#BrokerMessageBottom #messagePhone');
      for (let i = 0; i < forms.length; i++) {
        const form = forms[i];
        if (typeof form === 'undefined' || form === null) { continue; }

        form.addEventListener('submit', event => {
          event.preventDefault();

          const data = {
            'Id': form.elements['id'].value,
            'Name': form.elements['Name'].value,
            'Email': form.elements['Email'].value,
            'Phone': form.elements['Phone'].value,
            'Message': form.elements['Message'].value,
            'AcceptContacts': form.elements['AcceptContacts'].checked ? 1 : 0
          };

          let invalid = null;

          if (data.Name === null || /^\s*$/i.test(data.Name)) invalid = 'É preciso preencher o nome.';

          if (invalid === null && (data.Email === null || /^\s*$/i.test(data.Email))) invalid = 'É preciso preencher o e-mail.';

          if (invalid === null && (data.Message === null || /^\s*$/i.test(data.Message))) invalid = 'É preciso preencher o conteúdo da mensagem.';
          if (invalid != null) {
            window.creciAlert.addAlert('Contato', invalid, 'danger');

            return false;
          }

          const formData = new FormData(form);
          const url = form.getAttribute('action');
          axios.post(url, formData)
            .then(result => {
              let type = result.data.type;
              if (typeof grecaptcha !== 'undefined' && grecaptcha.reset) {
                try {
                  if (grecaptcha.reset.length >= 1) grecaptcha.reset(0);
                  if (grecaptcha.reset.length >= 2) grecaptcha.reset(1);
                } catch (e) {
                  console.warn('Erro ao resetar reCAPTCHA:', e);
                }
              }
              result.data.messages.forEach(function (message) {
                window.creciAlert.addAlert('Contato', message, type);
              });
            })
            .catch(reason => {
              console.warn('Contact', reason);
            });

          return false;
        });
      }
    }

    function generateChangeContainerSizeFunction(bodyFather, viewers) {
      return function () {
        const height = (bodyFather.offsetWidth * 9) / 16;
        const width = bodyFather.offsetWidth;

        for (var i = 0; i < viewers.length; i++) {
          let viewer = viewers[i];

          viewer.container.style.width = width + 'px';
          viewer.container.style.height = height + 'px';
          // Fix control bar width, since it cannot be altered via plugin options or CSS
          viewer.widget.barElement.querySelector('span > span:nth-child(2)').style.width = "calc(100% - 132px)";
          viewer.onWindowResize(width, height);
        }
      }
    }

    if (document.querySelector('.real-estate .return-page-result-search')) {
      document.querySelector('.real-estate .return-page-result-search').addEventListener('click', function () {
        window.history.back();
      });
    }
  });
